/**
 * Pure helper for the embedded quiz-player's postMessage language signal.
 *
 * quiz-player emits `{ eventType: 'LANGUAGE_CHANGED', language: <localeCode> }`
 * when the language changes via the player's own selector AFTER launch (in-place
 * HotSwapping, no reload). This extracts the new locale so the React wrapper can
 * follow it and stay in sync with the embedded player. The caller normalises the
 * raw code (normalizeLocale) before use. Mirrors leaderboard/first-to-flag's helper.
 */
export interface QuizPlayerMessage {
	eventType?: string;
	language?: unknown;
	[key: string]: unknown;
}

export function languageFromEvent(
	data: QuizPlayerMessage | null | undefined,
	currentLocale: string
): string | null {
	if (!data || data.eventType !== "LANGUAGE_CHANGED") return null;
	const lang = typeof data.language === "string" ? data.language.trim() : "";
	if (!lang || lang === currentLocale) return null;
	return lang;
}
